<template>
  <div>
    <h1>Error Layout</h1>
    <slot />
  </div>
</template>
